import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { LegadoConfigDispatcher } from "./Variables";
import { ActionType } from "../../../../../../react-core/Flux/ActionType";

export interface LegadoConfigStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    isLegadoEnabled?: boolean;
}

export class LegadoConfigStoreStatic extends BaseStore<LegadoConfigStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(LegadoConfigDispatcher, (actionData) => this.onLegadoConfigStoreResponse(actionData));
    }

    public getLastResult(): LegadoConfigStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): LegadoConfigStoreStaticState {
        return { actionType: ActionType.Loading };
    }

    public getLegadoConfigInfo(): boolean {
        return this.getState().isLegadoEnabled;
    }

    private onLegadoConfigStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({
                    actionType: actionData.actionType,
                    isLoading: false,
                    isLegadoEnabled: actionData.payload,
                });
                break;
            case ActionType.Error:
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}